import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this tied to a dance syllabus or exam board?',
  a: 'No. It uses common recreational dance steps — jazz, hip-hop, musical theatre and creative movement basics — written in plain English. It is not affiliated with any dance organization or syllabus and works alongside whatever training you have.'
}, {
  q: "It's a PDF. How will I learn the choreography from paper?",
  a: 'Every Combo Card is written in 8-counts, one row per eight, with directions from the dancer’s point of view, simple top-down floor diagrams and a symbol legend on page 2 of each volume. Bonus 02, the 10-Minute Combo Decoder, takes you from the card to dancing it full-out in about 10 minutes.'
}, {
  q: 'What ages is it for?',
  a: 'Recreational groups of kids aged 6 to 12 — studio, after-school and community-center classes. The three levels (Starter, Core and Stretch) let a mixed-age room dance the same combo at the same time.'
}, {
  q: "I don't want to teach someone else's style.",
  a: 'You won’t have to. Every Combo Card has a “Make It Yours” space, and Bonus 04, the Style Swap Guide, turns any combo into hip-hop, jazz, musical theatre or lyrical without changing the counts or the levels.'
}, {
  q: 'Do I have to start at Week 1?',
  a: 'No. Bonus 01, the Start Anywhere Season Planner, maps the 40 weeks to your calendar whether you start in September, January or mid-term — including 10 to 12-week terms.'
}, {
  q: 'What about music?',
  a: 'Every combo lists BPM, style and structure, never song titles or lyrics. You teach it to any clean, age-appropriate music you are licensed to play. Bonus 03, the 40-Week Music Map, gives you search phrases for every week.'
}, {
  q: 'Is it safe for young kids?',
  a: 'Turns, jumps and floor work come with step-by-step progressions and safety cues — soft landings, no full head rolls, knee- and wrist-friendly technique — plus signs to stop and refer. It does not replace your own supervision, first-aid training or your venue’s policies.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Landscape PDFs that read well on a phone or tablet mid-class and print cleanly for the studio.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-cream text-ink" data-id="element-85" data-mp="28h5f33tevydu">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-86" data-mp="23ghqeosnntms">
        <div className="text-center" data-id="element-87" data-mp="1zfxq5ccsc9wf">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-coral-deep" data-id="element-88" data-mp="1zew82nxcqn57">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-89" data-mp="s09jkb66xw5b">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-90" data-mp="2zmayotxpdspc">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-cream-dark bg-white" data-id="element-91" data-mp="38ok79e9evc03" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-plum focus:outline-none focus-visible:ring-2 focus-visible:ring-coral" data-id="element-92" data-mp="3dhdeq9w9kyfv">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-coral-deep" aria-hidden="true" data-id="element-93" data-mp="1x1sl1bixhtvt" /> : <PlusIcon className="h-5 w-5 flex-none text-coral-deep" aria-hidden="true" data-id="element-94" data-mp="221f2jx5shwaf" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-95" data-mp="11rm1d21k9pra">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}